/**
 *
 * @constructor
 */
function ToDoPage() {
    /**
     *
     */
    ToDoPage.prototype.initialize = function (console, mesh) {
        this.id = "toDo";
        this.console = console;
        this.mesh = mesh;

        return this;
    };

    /**
     *
     */
    ToDoPage.prototype.show = function () {
        var deferred = $.Deferred();

        this.mode = 'error';
        this.console.Ui.turnOn("errorLogLevel");

        // TODO Get from history/local storage

        this.sortAscending = false;
        this.sortCriterion = 'start';

        this.console.consoleService.getTasks(this.mesh).done(function (tasks) {
            this.tasks = tasks;

            jQuery.getScript(this.console.consoleService.portalServerUrl + "/thing-it/mashups/mashups.js").done(function () {
                deferred.resolve();
            }).fail(function (error) {
                console.log(error);
                deferred.reject(error);
            }.bind(this));
        }.bind(this)).fail(function (error) {
            console.log(error);
            deferred.reject(error);
        }.bind(this));

        return deferred.promise();
    };

    /**
     *
     */
    ToDoPage.prototype.leave = function () {
    };

    /**
     *
     */
    ToDoPage.prototype.filtered = function (task) {
        if (!this.filter || this.filter.length == 0) {
            return true;
        }

        if (task.processInstance.process.label.toLowerCase().indexOf(this.filter.toLowerCase()) >= 0 || task.activity.label.toLowerCase().indexOf(this.filter.toLowerCase()) >= 0) {
            return true;
        }

        return false;
    };

    /**
     * Null argument means "execute sort again"
     */
    ToDoPage.prototype.changeSort = function (criterion) {
        if (this.sortCriterion === criterion) {
            this.sortAscending = !this.sortAscending;

            this.tasks.reverse();
        } else {
            if (criterion) {
                this.sortCriterion = criterion;
            }

            if (this.sortCriterion === 'start' || this.sortCriterion === 'lastModification') {
                this.tasks.sort(function (a, b) {
                    return a[this.sortCriterion] - b[this.sortCriterion];
                });
            } else {
                this.tasks.sort(function (a, b) {
                    return a[this.sortCriterion].toLowerCase().localeCompare(b[this.sortCriterion].toLowerCase());
                });
            }
        }
    };

    /**
     *
     */
    ToDoPage.prototype.isPartial = function () {
        if (!this.task) {
            return false;
        }

        return this.task.externalWebAppUri.indexOf('/thing-it/mashups') == 0 || this.task.externalWebAppUri.indexOf('/portal/meshes') == 0;
    };

    /**
     *
     */
    ToDoPage.prototype.partialUri = function () {
        return 'http://localhost:3000' + this.task.externalWebAppUri;
    };

    /**
     *
     */
    ToDoPage.prototype.activateTask = function (task) {
        var deferred = jQuery.Deferred();

        this.console.consoleService.activateTask(task.oid).done(function (activatedTask) {
            task.externalWebAppUri = activatedTask.externalWebAppUri;
            task.data = activatedTask.data;
            this.task = task;

            this.initializeTaskUi();

            this.console.safeApply();
            deferred.resolve();
        }.bind(this)).fail(function (error) {
            console.error(error);

            deferred.reject(error);
        }.bind(this));

        return deferred.promise();
    };

    /**
     *
     */
    ToDoPage.prototype.initializeTaskUi = function () {
        if (this.task.externalWebAppUri && this.isPartial(this.task)) {
            window.setTimeout(function () {
                this.initializeController();
                this.parent.safeApply();
            }.bind(this), 1000);
        }

        // TODO Something for external controller
    };

    /**
     *
     */
    ToDoPage.prototype.initializeController = function () {
        console.log('Controller', Utils.extractQueryParameters(this.task.externalWebAppUri).controller);
        console.log('Controller', thingIt.controllers[Utils.extractQueryParameters(this.task.externalWebAppUri).controller]);

        this.mashupPanel = new thingIt.controllers[Utils.extractQueryParameters(this.task.externalWebAppUri).controller];
        this.mashupPanel.portal = this.console;
        this.mashupPanel.portalService = this.console.consoleService;
        this.mashupPanel.task = this.task;

        if (this.mashupPanel.initialize) {
            this.mashupPanel.initialize();
        }
    };

    /**
     *
     */
    ToDoPage.prototype.completeTask = function () {
        var deferred = jQuery.Deferred();
        var issues = [];

        if (this.mashupPanel &&
            this.mashupPanel.validate) {
            issues = this.mashupPanel.validate('complete');
        }

        if (issues.length > 0) {
            this.console
                .openMessageDialog(issues[0].content, 'error');

            deferred.resolve();
        } else {
            this.console.consoleService.completeTask(this.task).done(function (tasks) {
                this.task = null;
                this.tasks = tasks;

                this.changeSort();
                this.console.safeApply();
                deferred.resolve();
            }.bind(this)).fail(function (error) {
                console.error(error);

                deferred.reject(error);
            }.bind(this));
        }

        return deferred.promise();
    };

    /**
     *
     */
    ToDoPage.prototype.suspendTask = function () {
        var deferred = jQuery.Deferred();

        this.console.consoleService.suspendTask(this.task.oid).done(function () {
            this.task = null;

            this.console.safeApply();
            deferred.resolve();
        }.bind(this)).fail(function (error) {
            console.error(error);

            deferred.reject(error);
        }.bind(this));

        return deferred.promise();
    };

    /**
     *
     */
    ToDoPage.prototype.suspendAndSaveTask = function () {
        var deferred = jQuery.Deferred();

        this.console.consoleService.suspendAndSaveTask(this.task).done(function () {
            this.task = null;
            this.tasks = tasks;

            this.changeSort();
            this.console.safeApply();
            deferred.resolve();
        }.bind(this)).fail(function (error) {
            console.error(error);

            deferred.reject(error);
        }.bind(this));

        return deferred.promise();
    };
}
